/* eslint-disable */
// @ts-nocheck --- turn it back to .js file

import React from 'react';
import cryptoUtils from '../dataProvider/cryptoproxy/cryptoUtil';
import { isMobile, isTablet, isIOS } from 'react-device-detect';

const isHttp = window.location.protocol === 'http:';
export const isNotDev = process.env.NODE_ENV !== 'development';
const isPPP = window.location.href.indexOf('ppp=1') !== -1;

export const useCryptoProxy = (isNotDev && isHttp) || isPPP;
//const hostHasCryptoProxy = window.location.hostname.startsWith('app.');
//export const cryptoProxy = 'http://s2.xiaogezi.site';
//export const cryptoProxy = 'http://app.xiaogezi.site/api';
export const cryptoProxy = isHttp && isNotDev
    ? 'http://' + window.location.hostname + '/api'
    : 'http://app.alphaomega.top/api';
//export const cryptoProxy = 'http://localhost:8000';
//export const cryptoProxyHost = 'ws://s2.xiaogezi.site';
//export const cryptoProxyHost = 'localhost:8000';
export const cryptoProxyHost = isHttp && isNotDev
    ? 'ws://' + window.location.hostname
    : 'ws://app.alphaomega.top';

export const legitHosts = ["idigest.app", "xiaogezi.site", 'xwa2.site', "kcenter.top", "alphaomega.top"];

//now, all domain has standardized, we don't need this legit..
//const whichHost = legitHosts.findIndex((hh)=>window.location.href.includes(hh));
//const host = legitHosts[whichHost===-1 ? 4 : whichHost];
//const HostURL = 'https://' + host;
//const useLegit = isHttp || !isNotDev;
const isPreview = window.location.href.startsWith('https://gracetech.s3.us-west-004.backblazeb2.com');
//export const SERVER_HOST = isPreview ? 'https://idigest.app' : (useLegit ? host : window.location.hostname);
//export const SERVER_URL = isPreview ? 'https://idigest.app' : (useLegit ? HostURL : 'https://' + window.location.hostname);
export const SERVER_HOST = (isPreview || !isNotDev) ? 'idigest.app' : window.location.hostname;
export const SERVER_URL = (isPreview || !isNotDev) ? 'https://idigest.app' : 
  window.location.protocol + '//' + window.location.hostname;

console.log('init:', useCryptoProxy, window.location.protocol, cryptoProxy);

//local, <preview:todo>, and production API URL
export const HostOfficialServer = SERVER_URL + '/api'; //"https://s2.idigest.app";
export const HostApiLocal = 'http://localhost:3001';

const domainParts = window.location.hostname.split(".");
const baseDomain = domainParts.slice(-2);

export const pubContentUrl = HostOfficialServer; //"https://s2.idigest.app";

export const pwaUrl = window.location.href.startsWith("http://localhost")
  ? "http://penguin.linux.test/pwa/"
  : "https://pwa." + baseDomain[0] + "." + baseDomain[1];

// Local webapp template (legacy - has all webapp code built-in)
export const phoneEmulatorTemplate = "./html/template.html";

// Mobile template (copied from iDigest repo) + webapp overrides injected at runtime
export const mobileTemplateUrl = "./html/mobile-template.html";
export const webappOverridesUrl = "./html/webapp-overrides.js";
export const bibleJsUrl = "./html/bible.js";
export const bibleJsonUrl = "./html/bible.json";

// function to parse token
// in order to get the userid
function parseJwt(token) {
  let base64Url = token.split('.')[1];
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
}

export function getJwtObj() {
  const token = localStorage.getItem('access_token');
  if (!!token) {
    try {
      return parseJwt(token);
    } catch (error) {
      alert(error);
      // wrong Jwt, logout
      wipeSignInState();
    }
  }

  return {
    userId: -1,
    loginId: 'N/A'
  };
}

export function isUserSignedIn() {
  const token = localStorage.getItem('access_token');
  return !!token;
}

export function getToken() {
  const token = localStorage.getItem('access_token');
  return token;
}

export function getAuthStr() {
  const token = localStorage.getItem('access_token');
  return 'Bearer '.concat(token ? token : '');
}

export function getAccessToken() {
  const token = localStorage.getItem('access_token');
  return token;
}

export function logoutUser(logout) {
  if (logout) {
    setTimeout(() => document.location.reload(true), 3000);
  }
}

export function getSignInInfo() {
  if (!localStorage.getItem('access_token')) {
    return { name: 'Sign In', key: 'login' };
  } else {
    const userName = localStorage.getItem('displayName');
    return { name: userName + ' signed in', key: 'logout' };
  }
}

export function wipeSignInState() {
  localStorage.setItem('displayName', '');
  localStorage.setItem('churchName', '');
  localStorage.setItem('access_token', '');
  localStorage.setItem('isChurchAdmin', '');
  localStorage.setItem("SignInState", '');
  localStorage.setItem("sessionState", '');
  localStorage.setItem("myProfile", '');

  if (window.___appsocket) {
    window.___appsocket.close();
  }
  if (window.___socket) {
    window.___socket.close();
  }
  cryptoUtils.reset();
  window.location.href = '/';
  return;
}
export function getSignOut() {
  const yes = prompt('You sure want to sign out? type in yes');
  if (yes === 'yes') {
    wipeSignInState();
    logoutUser(true);
  }
  return;
}

//exports.logoutUser = logoutUser;

export function loadFrame(frameName, bookContent, day, scroll2Bottom) {
  var scrollTop = scroll2Bottom ? -1 : 0;
  const content = {
    book: {
      title: bookContent.bookTitle //need to get book title
    },
    lesson: {
      title: bookContent.title,
      sessions: bookContent.sessions // the lesson title
      //background: this.props.bookContent.background || './html/background.jpg'
    },
    //group: this.group,
    //groups: this.props.groups,
    //answers: this.props.answers,
    /*images: {
      home: Asset.fromModule(require('../assets/images/home.png')).uri,
      group: Asset.fromModule(require('../assets/images/icon-Group.png')).uri,
      note: Asset.fromModule(require('../assets/images/note.png')).uri
    },*/
    //unreadChat: this.getUnreadChat(),
    position: { day,  scrollTop}
    //newGroupMessage
  };

  const previewFrame = window.frames[frameName];
  console.log(content);
  previewFrame.content = content;
  previewFrame.initContent();
}

export function reLoadFrame(id, uri) {
  if (document && document.getElementById(id)) document.getElementById(id).src = uri;
}

export const signInSignOut = (props) => {
  return (
    <div style={{height:'auto',marginLeft:'5px'}}>
      <p>Register in iDigest App</p>
      <label for="loginId">User ID</label>
      <input id="loginId"/>
      <label for="password">Password</label>
      <input type="password" id="password"></input>
      <button>Sign in</button>
    </div>
  );
}

const elem = document.getElementById('root');
let rootDivStyle = {};
if (elem) {
  const rootDivStyle = getComputedStyle(elem);
  console.log('computed styles: ', rootDivStyle.minWidth);
}
/*
let testSmallScreen = false;
if (typeof window.matchMedia === 'function') {
  // jest test time there is no matchMedia function!
  const x = window.matchMedia('(max-width: 640px)');
  testSmallScreen = x.matches;
}

export const _smallScreen = testSmallScreen;
*/

// Or more specifically, exclude only iPads
const isIpad = isIOS && isTablet;
const isMobileExcludingIpad = isMobile && !isIpad;

export const _smallScreen = rootDivStyle.minWidth === '360px' || isMobileExcludingIpad;

